import { NAV } from "@/constants/testIds";
import { Button } from "@/components/ui/button";
import { FAMILY_PORTAL_URL, MAIN_SITE_URL } from "@/lib/links";

const LOGO_URL = "/bookshelf-logo.png";

export default function SiteHeader() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[rgba(250,246,238,0.85)] border-b border-stone-200/70">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <a
          href={MAIN_SITE_URL}
          target="_blank"
          rel="noreferrer"
          data-testid={NAV.brandLink}
          className="flex items-center gap-3 group"
        >
          <span className="block h-14 w-14 rounded-xl bg-white shadow-sm overflow-hidden grid place-items-center group-hover:scale-[1.02] transition-transform ring-1 ring-stone-200 p-1.5">
            <img
              src={LOGO_URL}
              alt="The Bookshelf Project, Inc. logo"
              className="h-full w-full object-contain"
            />
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-lg font-semibold tracking-tight text-[#122036]">
              The Bookshelf Project, Inc.
            </span>
            <span className="text-[11px] text-[#3DA9DC] uppercase tracking-[0.18em] font-semibold mt-0.5">
              Creating in-home libraries for children
            </span>
          </span>
        </a>

        <a
          href={FAMILY_PORTAL_URL}
          target="_blank"
          rel="noreferrer"
          data-testid={NAV.registerLink}
        >
          <Button className="bg-[#3DA9DC] hover:bg-[#2C8FBE] text-white rounded-full px-6 py-5 text-sm sm:text-base shadow-sm">
            Request a library
          </Button>
        </a>
      </div>
    </header>
  );
}
